export default "__VITE_ASSET__CMFufyxH__"